// import React, { useEffect, useMemo, useState } from "react";
// import { Link, useHistory } from "react-router-dom";
// import GroupAdminHeader from "../../../../Comman/Header";
// import GroupAdminSidebar from "../../../../Comman/Sidebar";
// import GroupAdminUperSide from "../../../../Comman/UperSide";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { connect } from "react-redux";
// import { getBranchList } from "../../../../../Store";
// import useDrawer from "../../../../../context/DrawerContext";
// import Select from "react-select";
// import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
// import {
//   branchfilterAndMapData,
//   getPlaceholder,
//   getSelectOptions,
// } from "../../../../Comman/BranchList";
// import useWindowHeight from "../../../../NewTableCommon/useWindowsPosition";
// import ColumPopoverCommon from "../../../../NewTableCommon/ColumPopoverCommon";
// import TableFilter from "../../../../NewTableCommon/tableFilter";
// import { selectStyles } from "../../../../Comman/CommonFunction/CommonFunction";
// import api from "../../../../../CommonApi/axios";
// import headers from "../../../../../CommonApi/headers";

// function GroupAdminPrintTypeConfiguration({ getBranchList, BranchList_ }) {
//   const [printTypes, setPrintTypes] = useState([]);
//   const [BranchId, setBranchID] = useState("");

//   const filteredOptions = branchfilterAndMapData(BranchList_);
//   const windowHeight = useWindowHeight();
//   const { drawerPos, handleDrawer, mainClassCustome } = useDrawer();

//   let history = useHistory();
//   var pathname = window.location.pathname;
//   var pathnamesplits = pathname.split("/");
//   var url = pathnamesplits[4];

//   // 🔥 FETCH PRINT TYPES API
//   const fetchPrintTypes = async (branchId) => {
//     try {
//       const res = await api.get(`/groupadmin/printer/print-types`, {
//         params: { branch_id: branchId },
//         headers,
//       });

//       console.log("PRINT TYPES:", res.data);
//       setPrintTypes(res.data?.data || []);
//     } catch (err) {
//       console.error(err?.response?.data?.error?.message || err.message);
//     }
//   };

//   // 🔥 Load branch list
//   useEffect(() => {
//     getBranchList();
//   }, []);

//   // 🔥 Set default branch
//   useEffect(() => {
//     if (!BranchId && filteredOptions?.length > 0) {
//       const defaultBranch = {
//         label: filteredOptions[0].label,
//         value: filteredOptions[0].value,
//       };
//       setBranchID(defaultBranch);
//     }
//   }, [filteredOptions]);

//   // 🔥 Call API when branch changes
//   useEffect(() => {
//     if (!BranchId?.value) return;

//     console.log("Calling API with branch_id:", BranchId.value);
//     fetchPrintTypes(BranchId.value);
//   }, [BranchId]);

//   // 🔥 TABLE COLUMNS
//   const Columns = useMemo(() => [
//     {
//       accessorKey: "print_type",
//       header: "Print Type",
//       Cell: ({ row }) => row?.original?.print_type || "---",
//     },
//     {
//       accessorKey: "printer_name",
//       header: "Printer",
//       Cell: ({ row }) => row?.original?.printer_name || "---",
//     },
//     {
//       header: "Action",
//       Cell: ({ row }) => (
//         <button
//           className="btn btn-sm btn-light-primary"
//           onClick={() => console.log("Edit:", row.original)}
//         >
//           Edit
//         </button>
//       ),
//     },
//   ], []);

//   const table = useMaterialReactTable({
//     columns: Columns,
//     data: printTypes,
//   });

//   return (
//     <React.Fragment>
//       <div
//         id="kt_body"
//         className="header-fixed header-tablet-and-mobile-fixed toolbar-enabled toolbar-fixed aside-enabled aside-fixed"
//       >
//         <div className="d-flex flex-column flex-root">
//           <div className="page d-flex flex-row flex-column-fluid">
//             <GroupAdminSidebar drawerPos={drawerPos} handleDrawer={handleDrawer} />
//             <ToastContainer />
//             <div
//               className="wrapper d-flex flex-column flex-row-fluid"
//               id="kt_wrapper"
//             >
//               <GroupAdminHeader />
//               <div
//                 className=" d-flex flex-column flex-column-fluid"
//                 id="kt_content"
//               >
//                 <div id="kt_content_container" className="mx-7">
//                   <main style={{ position: "initial", marginTop: "-27px" }} className={`main_ ${mainClassCustome.join(" ")}`}>
//                     <div className="row ">
//                       <div className="col-md-6">
//                         <div
//                           className="d-flex justify-content-start"
//                           data-kt-docs-table-toolbar="base"
//                         >
//                           <h1 style={{ marginTop: "9px" }} className="anchor fw-bolder mb-5">
//                             Settings 
//                           </h1>
//                           <div style={{ width: '2px', height: '33px', backgroundColor: '#D0D5DD' }} className="mx-4 mt-2" />

//                           <Select
//                             className="search-line"
//                             value={BranchId}
//                             placeholder={getPlaceholder(filteredOptions)}
//                             options={getSelectOptions(filteredOptions)}
//                             onChange={(opt) => {
//                               setBranchID(opt);
//                               sessionStorage.setItem(`${url}_branchName`, JSON.stringify(opt));
//                             }}
//                             styles={selectStyles}
//                           />



//                         </div>
//                       </div>
//                       <div className="col-md-6 text-end">
//                         <div
//                           className="d-flex justify-content-end"
//                           data-kt-docs-table-toolbar="base"
//                         >

//                           {(userPermissionType_ || UserPermissionAllData?.role_details?.settings?.find(permission =>
//                             permission?.key === "printer" &&
//                             permission?.access?.includes("create")
//                           )) && (
//                               <Addnewdetails url="/group_admin/settings/printer/printerSettings" Name="Add Printer" />
//                             )}
//                         </div>
//                       </div>
//                     </div>
//                     <hr style={{ opacity: 0.07, marginTop: 7 }} />
//                     <div className="row col-md-12 mb-4">
//                       <div
//                         className="col-md-9"
//                         data-kt-docs-table-toolbar="base"
//                       >
//                         <h3
//                           className="anchor fw-bolder mb-5 d-inline"
//                           id="custom-form-control"
//                         >
//                           Printer - Printer List
//                         </h3>
//                       </div>

//                       <div
//                         className="col-md-3 text-end"
//                         data-kt-docs-table-toolbar="base"
//                       >

//                       </div>
//                     </div>

//                     <div className="rounded border p-5">
//                       <ul className="nav nav-tabs nav-line-tabs mb-5 fs-6">
//                         <li className="nav-item">
//                           <Link
//                             to={{
//                               pathname:
//                                 "/group_admin/settings/printer/printerList",
//                             }}
//                             className={
//                               url === "printerList"
//                                 ? "nav-link active"
//                                 : "nav-link"
//                             }
//                           >
//                             Printer List
//                           </Link>
//                         </li>

                        
//                         {/* <li className="nav-item">
//                           <Link
//                             to={{
//                               pathname:
//                                 "/group_admin/settings/printer/printerSettings",
                              
//                             }}
//                             className={
//                               url === "printerSettings"
//                                 ? "nav-link active"
//                                 : "nav-link"
//                             }
//                           >
//                           Printer Settings
//                           </Link>
//                         </li> */}

//                         <li className="nav-item">
//                           <Link
//                             to={{
//                               pathname:
//                                 "/group_admin/settings/printer/printerCategory",
//                             }}
//                             className={
//                               url === "printerCategory"
//                                 ? "nav-link active"
//                                 : "nav-link"
//                             }
//                           >
//                             Printer Category
//                           </Link>
//                         </li>

//                         <li className="nav-item">
//                           <Link
//                             to={{
//                               pathname:
//                                 "/group_admin/settings/printer/printTypeConfig",
//                             }}
//                             className={
//                               url === "printerTypeConfig"
//                                 ? "nav-link active"
//                                 : "nav-link"
//                             }
//                           >
//                             Print Type Configuration
//                           </Link>
//                         </li>
//                       </ul>
//                       <div className="mt-5">
//                         <MaterialReactTable
//                           table={table}
//                         /></div>
//                     </div>
//                   </main>
//                 </div>
//               </div>
//             </div>

//             <ColumPopoverCommon
//               anchorEl_={anchorEl_}
//               handleClickColum_={handleClickColum_}
//               onColumnDataChange={onColumnDataChange}
//               handleCloseColum_={handleCloseColum_}
//               url23={url}
//             />

//             <TableFilter
//               open={isFilterPopoverOpen}
//               anchorEl={filterAnchorEl}
//               handleClose={handleFilterClose}
//               handleFilter={handleApplyFilters}
//               url23={url}
//             />
//             <GroupAdminUperSide />
//           </div>
//         </div>
//       </div>
//     </React.Fragment>
//   );
// }

// const mapStateToProps = (state) => ({
//   BranchList_: state.branchList,
// });

// const mapDispatchToProps = (dispatch) => {
//   return {
//     getBranchList: () => dispatch(getBranchList()),
//   };
// };

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(GroupAdminPrintTypeConfiguration);

import React, { useEffect, useMemo, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import GroupAdminHeader from "../../../../Comman/Header";
import GroupAdminSidebar from "../../../../Comman/Sidebar";
import GroupAdminUperSide from "../../../../Comman/UperSide";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { connect } from "react-redux";
import { getBranchList, getPrinterList } from "../../../../../Store";
import useDrawer from "../../../../../context/DrawerContext";
import { UserPermissionAllData, userPermissionType } from "../../../../Comman/UserPermission";
import Select from "react-select";
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import Addnewdetails from "../../../../Comman/AddNewDetails/Addnewdetails";
import { branchfilterAndMapData, getPlaceholder, getSelectOptions } from "../../../../Comman/BranchList";
import { HeaderStyle } from "../../OrderManagement/TableCommonModule";
import { tableOptionPrinterList, tableOptionPrintTypeList } from "../../../../NewTableCommon/tableOption";
import useWindowHeight from "../../../../NewTableCommon/useWindowsPosition";
import { renderStatusChipPrinteList } from "../../../../NewTableCommon/rendderStatucChipDaynamic";
import TableFilter from "../../../../NewTableCommon/tableFilter";
import ColumPopoverCommon from "../../../../NewTableCommon/ColumPopoverCommon";
import { selectStyles } from "../../../../Comman/CommonFunction/CommonFunction";
import api from "../../../../../CommonApi/axios";
import headers from "../../../../../CommonApi/headers";


function GroupAdminPrintTypeConfiguration({ getPrinterList, printerList, getBranchList, BranchList_ }) {

  const [printTypes, setPrintTypes] = useState([]);
  const [BranchId, setBranchID] = useState("");

  const filteredOptions = branchfilterAndMapData(BranchList_);
  const windowHeight = useWindowHeight();
  const { drawerPos, handleDrawer, mainClassCustome } = useDrawer();

  let history = useHistory();
  var pathname = window.location.pathname;
  var pathnamesplits = pathname.split("/");
  var url = pathnamesplits[4];

  // 🔥 FETCH PRINT TYPES API
  const fetchPrintTypes = async (branchId) => {
    try {
      const res = await api.get(`/groupadmin/printer/print-types/${branchId}`, {
        headers,
      });

      console.log("PRINT TYPES:", res.data);
      setPrintTypes(res.data?.data || []);
    } catch (err) {
      console.error(err?.response?.data?.error?.message || err.message);
    }
  };

  const updatePrinter = async (row, printer) => {
    try {
      const payload = {
        print_type_id: row._id,
        branch_id: BranchId.value,
        printer: printer,
      };

      console.log("UPDATE PAYLOAD:", payload);

      await api.post(
        `/groupadmin/printer/branch-print-type`,
        payload,
        { headers }
      );

      // Refresh table
      fetchPrintTypes(BranchId.value);

    } catch (err) {
      console.error(err?.response?.data?.error?.message || err.message);
    }
  };

  // 🔥 Load branch list
  useEffect(() => {
    getBranchList();
  }, []);

  // 🔥 Set default branch
  useEffect(() => {
    if (!BranchId && filteredOptions?.length > 0) {
      const defaultBranch = {
        label: filteredOptions[0].label,
        value: filteredOptions[0].value,
      };
      setBranchID(defaultBranch);
    }
  }, [filteredOptions]);

  // 🔥 Call API when branch changes
  useEffect(() => {
    if (!BranchId?.value) return;

    console.log("Calling API with branch_id:", BranchId.value);
    fetchPrintTypes(BranchId.value);
  }, [BranchId]);

  const userPermissionType_ = userPermissionType === "groupadmin"
  // const filteredOptions = branchfilterAndMapData(BranchList_);
  // const windowHeight = useWindowHeight();

  // let history = useHistory();
  // var pathname = window.location.pathname;
  // var pathnamesplits = pathname.split("/");
  // var url = pathnamesplits[4];
  const columnsDataString = sessionStorage.getItem(`${url}_columnData`);
  const columnsData = columnsDataString ? JSON.parse(columnsDataString) : null;
  const DisplayCol = columnsData && Object.values(columnsData).includes(false);
  const filterData = JSON.parse(sessionStorage.getItem(`${url}_filterData`));
  const branchName = JSON.parse(sessionStorage.getItem(`${url}_branchName`));

  const [updateColumns, setUpdateColumns] = useState(false);
  const ColumnsDataString = sessionStorage.getItem(`${url}_columnData`);
  const dineInColumnsData = ColumnsDataString ? JSON.parse(ColumnsDataString) : null;

  // const [BranchId, setBranchID] = useState(branchName || "");

  const [FilterData, SetFilterData] = useState("");
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [isFilterPopoverOpen, setIsFilterPopoverOpen] = useState(false);

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
    setIsFilterPopoverOpen(true);
  };

  const handleFilterClose = () => {
    setIsFilterPopoverOpen(false);
  };

  const handleApplyFilters = (filterData) => {
    setIsFilterPopoverOpen(false);
    SetFilterData(filterData)
  };

  const [anchorEl_, setAnchorEl_] = useState(null);

  const handleClickColum_ = (event) => {
    setAnchorEl_(event.currentTarget);
  };
  const handleCloseColum_ = () => {
    setAnchorEl_(null);
  };

  const onColumnDataChange = () => {
    setUpdateColumns(prevState => !prevState);
  };

  const VIEW = UserPermissionAllData?.role_details?.settings?.find(permission =>
    permission?.key === "printer")?.access?.includes("view")

  const DELETE = UserPermissionAllData?.role_details?.settings?.find(permission =>
    permission?.key === "printer")?.access?.includes("delete")

  const EDIT = UserPermissionAllData?.role_details?.settings?.find(permission =>
    permission?.key === "printer")?.access?.includes("edit")


  const formatPrintType = (name) => {
    if (!name) return "---";

    return name
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const Columns = useMemo(() => [
    {
      header: 'Sr.No',
      size: 60,
      Cell: ({ row }) => row.index + 1,
    },
    {
      accessorKey: 'name',
      header: 'Print Type',
      Cell: ({ row }) => formatPrintType(row?.original?.name) || "---",
    },
    {
      header: 'Action',
      Cell: ({ row }) => {
        const currentPrinter =
          row?.original?.printType?.printer ||
          row?.original?.printer ||
          "";

        return (
          <select
            className="form-select form-select-sm"
            value={currentPrinter}
            onChange={(e) =>
              updatePrinter(row.original, e.target.value)
            }
          >
            <option value="epson">Epson</option>
            <option value="sunmi">Sunmi</option>
          </select>
        );
      },
    },
  ], [BranchId]);

  const table = useMaterialReactTable({
    columns: Columns,
    data: printTypes,
    enableRowActions: false,
    ...tableOptionPrintTypeList({
      disableActions: true,
      getPrinterList,
      url,
      handleClickColum_,
      // handleSubmitActive,
      handleFilterClick,
      windowHeight,
      filterData,
      DisplayCol,
      DELETE, VIEW, EDIT, history
    }),
  });

  // console.log("filteredMenuList" ,filteredMenuList)

  // const { drawerPos, handleDrawer, mainClassCustome } = useDrawer();

  return (
    <React.Fragment>
      <div
        id="kt_body"
        className="header-fixed header-tablet-and-mobile-fixed toolbar-enabled toolbar-fixed aside-enabled aside-fixed"
      >
        <div className="d-flex flex-column flex-root">
          <div className="page d-flex flex-row flex-column-fluid">
            <GroupAdminSidebar drawerPos={drawerPos} handleDrawer={handleDrawer} />
            <ToastContainer />
            <div
              className="wrapper d-flex flex-column flex-row-fluid"
              id="kt_wrapper"
            >
              <GroupAdminHeader />
              <div
                className=" d-flex flex-column flex-column-fluid"
                id="kt_content"
              >
                <div id="kt_content_container" className="mx-7">
                  <main style={{ position: "initial", marginTop: "-27px" }} className={`main_ ${mainClassCustome.join(" ")}`}>
                    <div className="row ">
                      <div className="col-md-6">
                        <div
                          className="d-flex justify-content-start"
                          data-kt-docs-table-toolbar="base"
                        >
                          <h1 style={{ marginTop: "9px" }} className="anchor fw-bolder mb-5">
                            Settings 
                          </h1>
                          <div style={{ width: '2px', height: '33px', backgroundColor: '#D0D5DD' }} className="mx-4 mt-2" />

                          <Select
                            className="search-line"
                            value={BranchId}
                            placeholder={getPlaceholder(filteredOptions)}
                            options={getSelectOptions(filteredOptions).filter(opt => opt.value !== "All")}                            onChange={(opt) => {
                            setBranchID(opt);
                            sessionStorage.setItem(`${url}_branchName`, JSON.stringify(opt));
                            }}
                            styles={selectStyles}
                          />



                        </div>
                      </div>
                      <div className="col-md-6 text-end">
                        <div
                          className="d-flex justify-content-end"
                          data-kt-docs-table-toolbar="base"
                        >

                          {(userPermissionType_ || UserPermissionAllData?.role_details?.settings?.find(permission =>
                            permission?.key === "printer" &&
                            permission?.access?.includes("create")
                          )) && (
                              <Addnewdetails url="/group_admin/settings/printer/printerSettings" Name="Add Printer" />
                            )}
                        </div>
                      </div>
                    </div>
                    <hr style={{ opacity: 0.07, marginTop: 7 }} />
                    <div className="row col-md-12 mb-4">
                      <div
                        className="col-md-9"
                        data-kt-docs-table-toolbar="base"
                      >
                        <h3
                          className="anchor fw-bolder mb-5 d-inline"
                          id="custom-form-control"
                        >
                          Printer - Printer List
                        </h3>
                      </div>

                      <div
                        className="col-md-3 text-end"
                        data-kt-docs-table-toolbar="base"
                      >

                      </div>
                    </div>

                    <div className="rounded border p-5">
                      <ul className="nav nav-tabs nav-line-tabs mb-5 fs-6">
                        <li className="nav-item">
                          <Link
                            to={{
                              pathname:
                                "/group_admin/settings/printer/printerList",
                            }}
                            className={
                              url === "printerList"
                                ? "nav-link active"
                                : "nav-link"
                            }
                          >
                            Printer List
                          </Link>
                        </li>

                        
                        {/* <li className="nav-item">
                          <Link
                            to={{
                              pathname:
                                "/group_admin/settings/printer/printerSettings",
                              
                            }}
                            className={
                              url === "printerSettings"
                                ? "nav-link active"
                                : "nav-link"
                            }
                          >
                          Printer Settings
                          </Link>
                        </li> */}

                        <li className="nav-item">
                          <Link
                            to={{
                              pathname:
                                "/group_admin/settings/printer/printerCategory",
                            }}
                            className={
                              url === "printerCategory"
                                ? "nav-link active"
                                : "nav-link"
                            }
                          >
                            Printer Category
                          </Link>
                        </li>

                        <li className="nav-item">
                          <Link
                            to={{
                              pathname:
                                "/group_admin/settings/printer/printTypeConfig",
                            }}
                            className={
                              url === "printerTypeConfig"
                                ? "nav-link active"
                                : "nav-link"
                            }
                          >
                            Print Type Configuration
                          </Link>
                        </li>
                      </ul>
                      <div className="mt-5">
                        <MaterialReactTable
                          table={table}
                        /></div>
                    </div>
                  </main>
                </div>
              </div>
            </div>

            <ColumPopoverCommon
              anchorEl_={anchorEl_}
              handleClickColum_={handleClickColum_}
              onColumnDataChange={onColumnDataChange}
              handleCloseColum_={handleCloseColum_}
              url23={url}
            />

            <TableFilter
              open={isFilterPopoverOpen}
              anchorEl={filterAnchorEl}
              handleClose={handleFilterClose}
              handleFilter={handleApplyFilters}
              url23={url}
            />
            <GroupAdminUperSide />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  printerList: state.printerList,
  BranchList_: state.branchList,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getPrinterList: () => dispatch(getPrinterList()),
    getBranchList: () => dispatch(getBranchList()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupAdminPrintTypeConfiguration);
